function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 91,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 91,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint0_linear_1513:4055)",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint1_linear_1513:4055)",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint2_linear_1513:4055)",
  strokeWidth: 2
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 38,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 38,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint3_linear_1513:4055)",
  strokeWidth: 2
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M78.001 46.576h-2.464l-1.872 7.872h-.032l-1.952-7.872H69.33l-1.984 7.776h-.032l-1.808-7.776h-2.512L66.017 58h2.544l1.904-7.776h.032L72.433 58h2.496l3.072-11.424zM35.495 84.392h.032l1.44 4.192h-2.96l1.488-4.192zM29.911 93h2.544l.896-2.544h4.272L38.487 93h2.608l-4.272-11.424h-2.576L29.911 93zM65.688 89.208c-.048 2.816 2.336 4.064 4.864 4.064 3.12 0 4.752-1.568 4.752-3.664 0-2.576-2.544-3.136-3.392-3.328-2.864-.72-3.408-.848-3.408-1.728 0-.96.928-1.296 1.728-1.296 1.216 0 2.176.368 2.256 1.728h2.432c0-2.64-2.192-3.68-4.576-3.68-2.064 0-4.272 1.104-4.272 3.456 0 2.112 1.712 2.832 3.408 3.248 1.664.464 3.392.64 3.392 1.888 0 1.168-1.344 1.424-2.224 1.424-1.344 0-2.528-.592-2.528-2.112h-2.432zM103.686 83.688h1.792c2.48 0 3.296 1.472 3.296 3.776 0 2.528-1.392 3.424-2.848 3.424h-2.24v-7.2zM101.174 93h4.928c3.488 0 5.184-2.464 5.184-5.776 0-3.776-2.224-5.648-5.184-5.648h-4.928V93z",
  fill: "#fff"
});
var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 252,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 252,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint4_linear_1513:4055)",
  strokeWidth: 2
});
var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 217,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 217,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint5_linear_1513:4055)",
  strokeWidth: 2
});
var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 182,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 182,
  y: 73,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint6_linear_1513:4055)",
  strokeWidth: 2
});
var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 217,
  y: 38,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "#fff",
  strokeWidth: 2
});
var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 217,
  y: 38,
  width: 29,
  height: 29,
  rx: 6,
  stroke: "url(#onboarding-s2_svg__paint7_linear_1513:4055)",
  strokeWidth: 2
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M227.25 86.375l4.25 4.25 4.25-4.25",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M227.25 86.375l4.25 4.25 4.25-4.25",
  stroke: "url(#onboarding-s2_svg__paint8_linear_1513:4055)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M235.75 53.625l-4.25-4.25-4.25 4.25",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M235.75 53.625l-4.25-4.25-4.25 4.25",
  stroke: "url(#onboarding-s2_svg__paint9_linear_1513:4055)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M197.625 83.25l-4.25 4.25 4.25 4.25",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M197.625 83.25l-4.25 4.25 4.25 4.25",
  stroke: "url(#onboarding-s2_svg__paint10_linear_1513:4055)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M265.375 91.75l4.25-4.25-4.25-4.25",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M265.375 91.75l4.25-4.25-4.25-4.25",
  stroke: "url(#onboarding-s2_svg__paint11_linear_1513:4055)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint0_linear_1513:4055",
  x1: 105.5,
  y1: 72,
  x2: 105.5,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint1_linear_1513:4055",
  x1: 70.5,
  y1: 72,
  x2: 70.5,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint2_linear_1513:4055",
  x1: 35.5,
  y1: 72,
  x2: 35.5,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint3_linear_1513:4055",
  x1: 70.5,
  y1: 37,
  x2: 70.5,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint4_linear_1513:4055",
  x1: 266.5,
  y1: 72,
  x2: 266.5,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint5_linear_1513:4055",
  x1: 231.5,
  y1: 72,
  x2: 231.5,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint6_linear_1513:4055",
  x1: 196.5,
  y1: 72,
  x2: 196.5,
  y2: 103,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint7_linear_1513:4055",
  x1: 231.5,
  y1: 37,
  x2: 231.5,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint8_linear_1513:4055",
  x1: 231.5,
  y1: 86.375,
  x2: 231.5,
  y2: 90.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint9_linear_1513:4055",
  x1: 231.5,
  y1: 53.625,
  x2: 231.5,
  y2: 49.375,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint10_linear_1513:4055",
  x1: 197.625,
  y1: 87.5,
  x2: 193.375,
  y2: 87.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "onboarding-s2_svg__paint11_linear_1513:4055",
  x1: 265.375,
  y1: 87.5,
  x2: 269.625,
  y2: 87.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));
function SvgOnboardingS2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 140,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}
export default SvgOnboardingS2;